import { render, staticRenderFns } from "./ProgramAudioFiles.vue?vue&type=template&id=59fb5c35&scoped=true&"
import script from "./ProgramAudioFiles.vue?vue&type=script&lang=js&"
export * from "./ProgramAudioFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fb5c35",
  null
  
)

export default component.exports